/**
 * Developer fleet views (catalog v4) — client wrappers for the
 * developer-org-gated fleet callables. The /admin/vms page used to read
 * collectionGroup('infrastructure') directly (rules-denied, cross-tenant);
 * fleet data now flows only through rbacDevListFleetVms, which enforces the
 * developer-org gate + developer.fleet.view server-side.
 */
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';

// Always use the same default app instance so Functions shares auth state with Auth
const fns = () => getFunctions(getApp());

export interface DevFleetVmRecord {
  uid: string;
  accountId: string;
  accountLabel: string | null;
  assignmentMode: string | null;
  environment: string | null;
  instanceName: string;
  zone: string;
  machineType: string;
  status: string;
  ipAddress: string | null;
  healthy: boolean | null;
  lastHealthCheck: number | null;
  createdAt: number | null;
  tenantId: string | null;
}

export interface DevFleetHealthSummary {
  lastRun: number | null;
  totalVMs: number;
  healthyCount: number;
  unhealthyCount: number;
  unhealthyVMs: string[];
}

export interface DevListFleetVmsResult {
  vms: DevFleetVmRecord[];
  healthSummary: DevFleetHealthSummary | null;
}

export async function devListFleetVms(accountId?: string): Promise<DevListFleetVmsResult> {
  const fn = httpsCallable<{ accountId?: string }, DevListFleetVmsResult>(
    fns(),
    'rbacDevListFleetVms'
  );
  const res = await fn(accountId ? { accountId } : {});
  return res.data;
}
